module.exports = __webpack_public_path__ + "static/media/instagram.37ea31ad.svg";